import { MANAGED_DATA_WAREHOUSE } from '@spotify/confidence-graphql';

export const isManagedDataWarehouse = (
  warehouseName: string | null | undefined,
): boolean => warehouseName === MANAGED_DATA_WAREHOUSE;
